/**
 * UTM helpers — read once per session and persist in sessionStorage so the UTM
 * is captured even after the visitor navigates through the site before filling a form.
 */
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
const STORAGE_KEY = 'pec_utm';

function readUtmFromUrl() {
  if (typeof window === 'undefined') return {};
  const params = new URLSearchParams(window.location.search);
  const utm = {};
  UTM_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) utm[k] = v;
  });
  return utm;
}

export function getUtm() {
  if (typeof window === 'undefined') return {};
  // Persist whatever is in the URL on first visit
  try {
    const fromUrl = readUtmFromUrl();
    if (Object.keys(fromUrl).length > 0) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(fromUrl));
      return fromUrl;
    }
    const stored = sessionStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
}

export function getPageContext() {
  if (typeof window === 'undefined') return {};
  return {
    page_url: window.location.href,
  };
}
